//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export const DEFAULT_FAST_AMOUNTS_CURRENCY = 'USD';
export const FAST_AMOUNTS = {
  USD: [0.25, 5, 10],
  RUB: [20, 500, 1000],
  UAH: [10, 250, 500],
  EUR: [0.25, 5, 10]
};

export const BetType = {
  BALANCE: 'BALANCE',
  INVENTORY: 'INVENTORY'
};

export default {
  name: 'ManualBet',
  props: {
    fastAmounts:{ type: Array ,default: [0.25, 5, 10]},
    styling: { type: String, default: '' },
    betType: {
      type: String,
      required: true,
      validator: (val) => Object.values(BetType).includes(val)
    },
    betAmountUsd: { type: Number, default: 0 },
    showBonusItemTooltip: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    minBetEnabled: { type: Boolean, default: false },
    isStreamerMode: { type: Boolean, default: false },
    userCurrency: { type: String, default: 'USD' },
    userBalanceUsd: { type: Number, default: 0 },
    convertFn: {
      type: Function,
      default: (amount) => amount
    }
  },
  data() {
    return {
      BetType,
      internalBetType: this.betType,
      isMaxAmount: false,
      canClearAmount: false,
      betAmount: this.betAmountUsd,
      internalBetAmountUsd: this.betAmountUsd,
      fastAmountCurrency: DEFAULT_FAST_AMOUNTS_CURRENCY
    };
  },
  watch: {
    betType(newVal) {
      if (this.internalBetType === newVal) return;
      this.internalBetType = newVal;
      this.reset();
    },
    // 监听父组件/外部传入的金额变化，同步本地输入框
    betAmountUsd: {
      immediate: true,
      handler(newVal) {
        this.internalBetAmountUsd = newVal;
        this.betAmount = newVal;
        this.canClearAmount = newVal > 0;
        this.isMaxAmount = this.userBalanceUsd > 0 && newVal >= this.userBalanceUsd;
      }
    }
  },
  created() {
    this.setFastAmounts();
  },
  methods: {
    // 点击 0.25, 5, 10 等快捷按钮
    /*setFastAmounts() {
      if (FAST_AMOUNTS[this.userCurrency]) {
        this.fastAmountCurrency = this.userCurrency;
        this.fastAmounts = FAST_AMOUNTS[this.userCurrency];
      } else {
        this.fastAmountCurrency = DEFAULT_FAST_AMOUNTS_CURRENCY;
        this.fastAmounts = FAST_AMOUNTS[DEFAULT_FAST_AMOUNTS_CURRENCY];
      }
    },*/
    setFastAmount(amount) {
      this.isMaxAmount = false;
      this.canClearAmount = true;

      const convertedUsd = Number(this.convertFn(amount, this.fastAmountCurrency, 'USD'));
      this.internalBetAmountUsd = convertedUsd;
      this.betAmount = amount;

      this.emitBetAmountUpdate();
    },

    // 手动在 Input 框中输入
    onBetAmountChanged() {
      const numVal = Number(this.betAmount) || 0;

      if (numVal > 0) {
        this.internalBetAmountUsd = Number(this.convertFn(numVal, this.userCurrency, 'USD'));
        this.canClearAmount = true;
      } else {
        this.internalBetAmountUsd = 0;
        this.canClearAmount = false;
      }

      const maxBetAmount = this.userBalanceUsd || 0;
      this.isMaxAmount = maxBetAmount > 0 && this.internalBetAmountUsd >= maxBetAmount;

      this.emitBetAmountUpdate();
    },

    onBetAmountBlur() {
      if (!this.minBetEnabled) return;

      const MIN_BET_AMOUNT_USD = 0.25;
      if (typeof this.betAmount !== 'number' || this.internalBetAmountUsd < MIN_BET_AMOUNT_USD) {
        this.internalBetAmountUsd = MIN_BET_AMOUNT_USD;
        this.betAmount = Number(this.convertFn(MIN_BET_AMOUNT_USD, 'USD', this.userCurrency));
        this.emitBetAmountUpdate();
      }
    },

    // 点击 MAX 按钮
    setMaxAmount() {
      if (this.internalBetType === BetType.BALANCE) {
        this.internalBetAmountUsd = this.userBalanceUsd || 0;
        this.betAmount = Number(this.convertFn(this.internalBetAmountUsd, 'USD', this.userCurrency));
        this.emitBetAmountUpdate();
      } else if (this.internalBetType === BetType.INVENTORY) {
        this.$emit('select-all-inventory');
      }

      this.isMaxAmount = true;
      this.canClearAmount = true;
    },

    // 点击清空按钮
    clearAmount() {
      if (this.internalBetType === BetType.BALANCE) {
        this.betAmount = 0;
        this.internalBetAmountUsd = 0;
        this.emitBetAmountUpdate();
      } else if (this.internalBetType === BetType.INVENTORY) {
        this.$emit('reset-selected-items');
      }

      this.isMaxAmount = false;
      this.canClearAmount = false;
    },

    reset() {
      this.isMaxAmount = false;
      this.canClearAmount = false;
      this.emitBetAmountUpdate();
    },

    // 核心：向父组件发射更新事件
    emitBetAmountUpdate() {
      this.$emit('update:betAmountUsd', this.internalBetAmountUsd);
      this.$emit('change-bet-amount', this.internalBetAmountUsd);
    }
  }
};
